import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "grid-view",
  "use": "grid-view-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"grid-view\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <g fill=\"#2274a6\">\n            <g>\n                <path d=\"M20 16v4h-4v-4h4zm-8 0v4H8v-4h4zm-8 0v4H0v-4h4zm16-8v4h-4V8h4zm-8 0v4H8V8h4zM4 8v4H0V8h4zm0-8v4H0V0h4zm16 0v4h-4V0h4zm-8 0v4H8V0h4z\" transform=\"translate(-727 -3946) translate(727 3946)\" />\n            </g>\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/grid-view.svg
// module id = XGwp
// module chunks = 1